(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];
    function stateConfig($stateProvider) {
        $stateProvider
            .state('sales-funnel', {
                parent: 'admin',
                url: '/sales-funnel',
                data: {
                    authorities: ['STORE_READ_SHOWCASE'],
                    pageTitle: 'global.menu.admin.sales-funnel'
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/admin/sales-funnel/sales-funnel.html',
                        controller: 'SalesFunnelController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('sales-funnel');
                        $translatePartialLoader.addPart('communication');
                        $translatePartialLoader.addPart('customers');
                        $translatePartialLoader.addPart('change-log');
                        $translatePartialLoader.addPart('flyers');
                        return $translate.refresh();
                    }]
                }
            })
    }
})();
